import * as Yup from "yup";

export const reasonFormSchema = Yup.object().shape({
  reason: Yup.string().required("Reason is required"),
});
